module.exports = __webpack_public_path__ + "static/2-1c3f6fafa25f680e5b0cd95677124178.jpg";